import { type ROUTE_PATHS } from '@/shared/config/router/types';

export type EventName = string;

export interface PlatformEvent {
  type: string;
  created: number;
  user_properties: Record<string, any>;
  event_properties: Record<string, any>;
}

export interface ExtraValues<
  UserProperties = Record<string, any>,
  EventProperties = Record<string, any>,
> {
  type?: string;
  user_properties?: Partial<UserProperties>;
  event_properties?: Partial<EventProperties>;
}

export enum URL_SOURCES {
  PRIZE_PREMIUM = 'premium_prize_button',
  PRIZE_TON = 'ton_prize_button',
  PRIZE_BOOST = 'boost_prize_button',
  SPIN_THE_WHEEL = 'spin_the_wheel_button',
  INLINE = 'inline',
  GREETING_BUTTON = 'greeting_button',
  ONBOARDING_END_BUTTON = 'onboarding_end_button',
  PUSH = 'push_button',
  WHEEL_KEYBOARD_BUTTON = 'wheel_keyboard_button',
  TOP_MODAL = 'ivent_top_gateway',
}

export type RoutePathForAnalytics =
  | Lowercase<keyof typeof ROUTE_PATHS>
  | (string & NonNullable<unknown>);

export enum PROTOCOL {
  HTTP = 'http',
  WEBSOCKET = 'websocket',
}
